'use strict';

/* @ngInject */
export default class ConfirmDeleteModalController {
	public $uibModalInstance: any;
	public okFunction: any;
	public additionalText: any;

  constructor($uibModalInstance, okFunction, additionalText) {

    this.$uibModalInstance = $uibModalInstance;
    this.okFunction = okFunction;
    this.additionalText = additionalText;
  }


  cancel() {
    this.$uibModalInstance.close();
  };

  ok() {
    this.$uibModalInstance.close();
    this.okFunction();
  };

}
